import { createContext } from "react"
import { Campos, DataTabla, Ficha, ProcesoFichas, Seccion, Tabla } from "../../../documentacion/MiFicha/FIchaInterface"

interface ColaboradorObservacionContextProps {
    procesoFichaData: ProcesoFichas[],
    setProcesoFichaData: (value: ProcesoFichas[]) => void,
    message: string,
    setMessage: (value: string) => void,
    idProceso: string
    setIdProceso: (value: string) => void
    showKitDocumentoModal: boolean
    setShowKitDocumentoModal: (value: boolean) => void
}

const ColaboradorObservacionContext = createContext<ColaboradorObservacionContextProps>({
    procesoFichaData: [],
    setProcesoFichaData: (value) => {},
    message: '',
    setMessage: (value) => {},
    idProceso: '',
    setIdProceso: (value) => {},
    showKitDocumentoModal: false,
    setShowKitDocumentoModal: (value) => {}
})

export {ColaboradorObservacionContext}